import SwissReLanding from './SwissReModule';

export default SwissReLanding;
